import React from "react";
import ButtonPrimary from "../../shared/components/Buttons Medium/ButtonPrimary";

export default function BlogsLoadMore({children}) {
  return (
    <div className="row">
      <div className="col-md-12 avc-load-more">
        {children}
      </div>
    </div>
  );
}
